const t = "按 Enter 编辑", e = {
  pressEnterToEdit: t
};
export {
  e as default,
  t as pressEnterToEdit
};
